var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"more\"><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M0 7.5h16v1H0z\" /><path d=\"M7.5 0h1v16h-1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol